import { WithStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';

const styles = (theme: Theme) =>
	createStyles({
		base: {
			display: 'flex',
		},
		root: {
			flexGrow: 1,
			position: 'relative',
		},
	});

interface IDivProp extends React.HTMLAttributes<HTMLDivElement> {}

interface IProps extends React.Props<{}>, WithStyles<typeof styles>, IDivProp {}
class GridDivRow extends React.Component<IProps, {}> {
	public constructor(props: IProps) {
		super(props);
	}

	public render() {
		const { classes } = this.props;
		return (
			<div
				className={`${classes.base} ${classes.root}`}
				style={{ display: 'flex' }}
			>
				{this.props.children}
			</div>
		);
	}
}

export default GridDivRow;



// WEBPACK FOOTER //
// ./src/components/GridDivRow.tsx